import React from 'react'
import PropTypes from 'prop-types'
import { isEmpty, map } from 'lodash'

import DialogModal from 'components/DialogModal'

const DeletePrinterModal = ({
  isModalOpen,
  isBackup,
  configurationsWithSetReceiptPrinterName,
  isPrinterExists,
  deletePrinter,
  toggleModal,
}) => {
  const renderBackupPrinters = () => {
    if (isPrinterExists && isBackup) {
      return (
        <div className="modal__text">This printer is set as backup printer for other printers.</div>
      )
    }
  }

  const renderConfigurationsWithSetReceiptPrinterName = () => {
    if (!isEmpty(configurationsWithSetReceiptPrinterName)) {
      return (
        <div className="modal__text">
          Printer is set as the recipt printer for:
          <ul className="modal__list">
            {map(configurationsWithSetReceiptPrinterName, (configuration) => (
              <li className="modal__list-item" key={configuration.uuid}>
                {configuration.name}
              </li>
            ))}
          </ul>
        </div>
      )
    }
  }

  const modalBody = (
    <div className="dialog-modal__body-text">
      {renderConfigurationsWithSetReceiptPrinterName()}
      {renderBackupPrinters()}
    </div>
  )

  return (
    <>
      {isPrinterExists ? (
        <DialogModal
          closeModalCallback={toggleModal}
          confirmationCallback={deletePrinter}
          modalBody={modalBody}
          modalButtonText="OK"
          modalIsOpen={isModalOpen}
          modalTitle="Do you want to continue?"
        />
      ) : (
        <DialogModal
          closeModalCallback={toggleModal}
          confirmationCallback={deletePrinter}
          modalIsOpen={isModalOpen}
          modalTitle="Do you want to continue?"
        />
      )}
    </>
  )
}

DeletePrinterModal.propTypes = {
  isModalOpen: PropTypes.bool,
  isBackup: PropTypes.bool,
  configurationsWithSetReceiptPrinterName: PropTypes.array,
  isPrinterExists: PropTypes.bool,
  deletePrinter: PropTypes.func,
  toggleModal: PropTypes.func,
}

export default DeletePrinterModal
